import { apiClient, Auth } from '@/shared/api'

import { TPaymentWidgetInfo } from '../model/schema'

export const getTossPaymentWidgetInfo = async (contractId: number) => {
  const { data } = await apiClient.get<TPaymentWidgetInfo>({
    endpoint: '/payments/toss/widget-info',
    queryParams: {
      contractId,
    },
    auth: Auth.REQUIRED,
  })

  return data
}
